export default __webpack_public_path__ + "static/media/34.a2f3f07c.png";